<!--<p class="text-danger fw-bold">variant-swatch-list works!</p>-->

<span class="fw-normal mb-2 d-block">
  {{ 'product-variant-optie-selecteer-kleur-titel' | fromDictionary }}
  @if (hoverLabel || getSelectedOptionValue(option.name)) {
    -
    @if (!hoverLabel) {
      <span>{{ getSelectedOptionValue(option.name) }}</span>
    }
    @if (hoverLabel) {
      <span class="color-preview">{{ hoverLabel }}</span>
    }
  }
</span>

<ul class="swatch-list">
  @for (value of option.values; track value) {
    <li class="swatch-list__item">
      <a
        class="swatch"
        [class.is--active]="getSelectedOptionValue(option.name) === value"
        [class.is--inactive]="!isAvailable(option.name, value)"
        [routerLink]="[]"
        [queryParams]="getOptionAsQueryParam(option, value)"
        [queryParamsHandling]="'merge'"
        [replaceUrl]="true"
      [class.is--white]="
        value.toLowerCase() === 'wit' || value.toLowerCase() === 'white' || (!getSwatch(value).color && !getSwatch(value).image)
      "
        [style.--swatch-color]="getSwatch(value).color || 'white'"
        [style.--swatch-image]="getSwatch(value).image"
        (mouseenter)="hoverLabel = value"
        (mouseleave)="hoverLabel = undefined"
        >
        <span class="sr-only">Choose color: {{ value }}</span>
        @if (!isAvailable(option.name, value)) {
          <div class="swatch__cross"></div>
        }
      </a>
    </li>
  }
</ul>
